import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="flag-stripe-container">
        <div className="flag-stripe red"></div>
        <div className="flag-stripe white"></div>
        <div className="flag-stripe blue"></div>
      </div>
      <div className="header-content">
        <div className="stars-container">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="star"></div>
          ))}
        </div>
        <h1 className="header-title">TRUMP PRESIDENCY TRACKER</h1>
        <div className="stars-container">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="star"></div>
          ))}
        </div>
      </div>
      <p className="header-subtitle">TRACKING THE DAYS OF THE TRUMP PRESIDENCY (2025-PRESENT)</p>
      <div className="eagle-divider"></div>
    </header>
  );
}

export default Header;